import React from "react";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";

const ImageModalContext = React.createContext<{
  setUrl: (url: string[]) => void;
}>({
  setUrl: (_: string[]) => {},
});

const ImageModalProvider: React.FC = ({ children }) => {
  const [isShowModelImage, setIsShowModelImage] =
    React.useState<boolean>(false);
  const [url, setUrlState] = React.useState<string[]>([]);
  const [index, setIndex] = React.useState<number>(0);
  const setUrl = (url: string[]) => {
    setUrlState(url);
    setIsShowModelImage(true);
  };
  return (
    <ImageModalContext.Provider value={{ setUrl }}>
      {isShowModelImage && (
        <Lightbox
          closeLabel={url.length === 1 ? "true" : "false"}
          mainSrc={url[index]}
          nextSrc={url.length !== 1 ? url[(index + 1) % url.length] : undefined}
          prevSrc={
            url.length !== 1
              ? url[(index + url.length - 1) % url.length]
              : undefined
          }
          onCloseRequest={() => setIsShowModelImage(false)}
          onMovePrevRequest={() =>
            setIndex((index + url.length - 1) % url.length)
          }
          onMoveNextRequest={() => setIndex((index + 1) % url.length)}
        />
      )}
      {children}
    </ImageModalContext.Provider>
  );
};

export default ImageModalProvider;

export const useImageModal = () => React.useContext(ImageModalContext);
